import React from 'react';
import { bool } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { txIsCanceled, txIsDelivered, txIsDeclined } from '../../util/transaction';
import { propTypes } from '../../util/types';
import { TRANSITION_REQUEST_PAYMENT_CASH, TRANSITION_REQUEST_PAYMENT_CARD } from '../../util/transaction';

import css from './BookingBreakdown.module.css';

const LineItemUnitPrice = props => {
  const { transaction, isProvider, intl, currentPage } = props;

  let providerTotalMessageId = 'BookingBreakdown.providerTotalDefault';
  if (txIsDelivered(transaction)) {
    providerTotalMessageId = 'BookingBreakdown.providerTotalDelivered';
  } else if (txIsDeclined(transaction)) {
    providerTotalMessageId = 'BookingBreakdown.providerTotalDeclined';
  } else if (txIsCanceled(transaction)) {
    providerTotalMessageId = 'BookingBreakdown.providerTotalCanceled';
  }

  const totalLabel = isProvider ? (
    <FormattedMessage id={providerTotalMessageId} />
  ) : (
    <FormattedMessage id="BookingBreakdown.total" />
  );

  const totalPrice = isProvider
    ? transaction.attributes.payoutTotal
    : transaction.attributes.payinTotal;
  const formattedTotalPrice = formatMoney(intl, totalPrice);

  const paymentMethodSelected = (
    !!transaction.attributes?.transitions.find(t => t.transition === TRANSITION_REQUEST_PAYMENT_CASH) ||
    !!transaction.attributes?.transitions.find(t => t.transition === TRANSITION_REQUEST_PAYMENT_CARD));

  const paymentMethodCash = !!transaction.attributes?.transitions.find(t => t.transition === TRANSITION_REQUEST_PAYMENT_CASH)

  return (
    <>
      <hr className={css.totalDivider} />
      <div className={css.lineItemTotal}>
        <div className={css.totalLabel}>{totalLabel}</div>
        <div className={css.totalPrice}>{formattedTotalPrice}</div>
      </div>
      {currentPage !== "PaymentSelectionPage" && paymentMethodSelected && (
        <div className={css.lineItemTotal}>
          <div className={css.totalLabel}><FormattedMessage id="BookingBreakdown.paymentMethodLabel" /></div>
          <div className={css.totalPrice}>
            <FormattedMessage
              id={paymentMethodCash ? "BookingBreakdown.paymentMethodCash" : "BookingBreakdown.paymentMethodCard"}
            />
          </div>
        </div>
      )}
    </>
  );
};

LineItemUnitPrice.propTypes = {
  transaction: propTypes.transaction.isRequired,
  isProvider: bool.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemUnitPrice;
